import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'
import { ConceptualLabelScopes } from '../../constants/conceptual-label-scopes'

const initialState = {
    showCreateConceptualLabelDrawer: false,
    editingConceptualLabelId: null,
    createFormInitialValues: {},
    scope: ConceptualLabelScopes.ALL,
}

const conceptualLabelSlice = createSlice({
    name: 'conceptualLabel',
    initialState,
    reducers: {
        setShowCreateConceptualLabelDrawer: (state, action) => {
            state.showCreateConceptualLabelDrawer = action.payload
            if (action.payload === false) {
                state.createFormInitialValues = {}
            }
        },
        setEditingConceptualLabelId: (state, action) => {
            state.editingConceptualLabelId = action.payload
        },
        setCreateFormInitialValues: (state, action) => {
            state.createFormInitialValues = action.payload
        },
        setScope: (state, action) => {
            state.scope = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const conceptualLabelActions = conceptualLabelSlice.actions

export default conceptualLabelSlice.reducer
